<div class="table-responsive small">
  <p-table [value]="reports" [loading]="areClientsLoading" [lazy]="true" (onLazyLoad)="getClientsToCallOnLazy($event)"
    (onPage)="pageChange($event)" styleClass="p-datatable-striped" [paginator]="true" [(rows)]="rows" [(first)]="first"
    [totalRecords]="totalRecords" [rowsPerPageOptions]="[20, 50, 100]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [tableStyle]="{ 'min-width': '50rem' }" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">
          <div>Attorney Name</div>
          <div class="mt-2">
            <input type="text" class="form-control form-control-sm" placeholder="Search attorney..."
              [(ngModel)]="attorneyName" (ngModelChange)="onAttorneySearch($event)"
              (keydown.enter)="onAttorneySearchEnter(attorneyInput.value)" #attorneyInput />
          </div>
        </th>
        <th scope="col">
          <div>Matter Name</div>
          <div class="mt-2">
            <input type="text" class="form-control form-control-sm" placeholder="Search matter name..."
              [(ngModel)]="matterName" (ngModelChange)="onMatterNameSearch($event)"
              (keydown.enter)="onMatterNameSearchEnter(matterNameInput.value)" #matterNameInput />
          </div>
        </th>
        <th scope="col">
          <div>Matter Number</div>
          <div class="mt-2">
            <input type="text" class="form-control form-control-sm" placeholder="Search matter number..."
              [(ngModel)]="matterNumber" (ngModelChange)="onMatterNumberSearch($event)"
              (keydown.enter)="onMatterNumberSearchEnter(matterNumberInput.value)" #matterNumberInput />
          </div>
        </th>
        <th scope="col">Days Open</th>
        <th scope="col" *ngIf="surveyType.id === 11">Days since LWC</th>
        <th scope="col" *ngIf="surveyType.id === 9 || surveyType.id === 10">Days since last contact</th>
        <th scope="col">Completed Surveys</th>
        <th scope="col">MP</th>
        <th scope="col">Timezone</th>
        <th scope="col">Contact 1</th>
        <th scope="col">Contact 2</th>
        <th scope="col">Contact 3</th>
        <th scope="col">Notes</th>
        <th scope="col" style="min-width:130px;">
          <div>Rep</div>
          <div class="mt-2" *ngIf="accountInfo?.isAdmin">
            <select class="form-select form-select-sm" [(ngModel)]="searchRepId" (ngModelChange)="onRepSearch($event)">
              <option [ngValue]="undefined">All Reps</option>
              <option *ngFor="let rep of reps" [ngValue]="rep.employeeId"><span data-private>{{ rep.name }}</span></option>
            </select>
          </div>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-i="rowIndex" , let-m>
      <tr>
        <td><span data-private>{{ m.attorney ? m.attorney.name : '' }}</span></td>
        <td><span data-private>{{ m.matterName }}</span></td>
        <td>{{ m.matterNumber }}</td>
        <td>{{ m.daysOpen }}</td>
        <td *ngIf="surveyType.id === 11">{{ m.daysOpenLWC }}</td>
        <td *ngIf="surveyType.id === 9 || surveyType.id === 10">{{ m.numDaysLastContact }}</td>
        <td>{{ m.completedSurveys }}</td>
        <td>{{ m.mp }}</td>
        <td>{{ m.timeZone }}</td>
        <td>{{ m.call1 }}</td>
        <td>{{ m.call2 }}</td>
        <td>{{ m.call3 }}</td>
        <td><span data-private>{{ m.notes }}</span></td>
        <td>
          <form #repForm="ngForm">
            <label class="visually-hidden" [attr.for]="'rep-'+i">Select Representative:</label>
            <select [attr.id]="'rep-'+i" class="form-select form-select-sm" name="rep" [(ngModel)]="m.clientRepId"
              (change)="onRepChange(m)" [disabled]="!this.accountInfo?.isAdmin">
              <option [ngValue]="undefined" disabled>Select a Rep</option>
              <option *ngFor="let rep of reps" [ngValue]="rep.employeeId"><span data-private>{{ rep.name }}</span>
              </option>
            </select>
          </form>
        </td>
        <td>
          <ng-container *ngIf="m.clientRepId === null || m.clientRepId === undefined">
            <div class="d-inline" pTooltip="A rep must be assigned before a matter can be viewed."
              tooltipPosition="top">
              <button type="button" class="btn btn-link p-0 m-0" disabled>
                Details
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="m.clientRepId !== null && m.clientRepId !== undefined">
            <a class="btn btn-link p-0 m-0" [routerLink]="['/matters/details', m.matterId, surveyType.id, month, year]">
              Details
            </a>
            <a class="ms-1" title="Open in new tab" target="_blank"
              [routerLink]="['/matters/details', m.matterId, surveyType.id, month, year]"><fa-icon class="me-2"
                [icon]="faArrowUpRightFromSquare"></fa-icon></a>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="14" class="text-center py-4">
          There are no cases with the specified month/year combo.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>